import { type Action, FilterActionTypes, action } from "easy-peasy";

import DEFAULT_PEOPLE from "./default";
import { type LogEffect, createLogEffect } from "../../utils/store";

const logEffect = (property: keyof FilterActionTypes<PeopleModel>) =>
  createLogEffect<PeopleModel>("PEOPLE", property, false);

export type PeopleModel = {
  value: number;
  valueOnChange: LogEffect<PeopleModel>;
  set: Action<PeopleModel, number>;
};

const peopleModel: PeopleModel = {
  value: DEFAULT_PEOPLE,
  valueOnChange: logEffect("value"),
  set: action((state, payload) => {
    state.value = payload;
  }),
};

export default peopleModel;
